import React from 'react'
import PropTypes from 'prop-types'
import toFinalFormInput from '../FormElements/toFinalFormInput'
import { Group, Btn } from './styles'

const getValue = val => {
  if (typeof val === 'object' && val.value) {
    return val.value
  }
  return val
}

const ButtonGroup = ({ defaultValue, value, options, onChange, disabled }) => {
  return (
    <Group disabled={disabled}>
      {
        options.map(option => (
          <Btn
            key={option.value}
            selected={option.value === getValue(value)}
            onClick={() => disabled ? null : onChange(option.value)}
          >
            {option.label}
          </Btn>
        ))
      }
    </Group>
  )
}

ButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
      label: PropTypes.node.isRequired
    }).isRequired
  ).isRequired
}

export const FinalButtonGroup = toFinalFormInput(ButtonGroup)

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/Components/ButtonGroup/ButtonGroup.jsx